<div
  *ngIf="service.category !== Category.SPECIAL_NEED; else specialNeed"
  class="flex border-top-dashed ps-small-t"
  [class.flex--row]="(isMobile$ | async) === false"
  [class.flex--column]="(isMobile$ | async) === true"
>
  <div class="flex white-bg overflow-hidden relative flex-1">
    <div class="flex--basis100 relative">
      <fcom-image
        *ngIf="article$ | finMap: 'picture' | async as picture"
        class="picture block border-top border-left border-right border"
        [ratio]="'1x1'"
        [fillParent]="true"
        [scale]="false"
        [imageData]="picture"
      />
    </div>
    <div class="flex-1 flex--basis0 ps-medium-l">
      <div class="pr-small-b" [innerHTML]="article$ | finMap: 'teaserText' | async"></div>
    </div>
  </div>
  <div
    class="flex"
    [class.flex--column]="(isMobile$ | async) === false"
    [class.flex--row]="(isMobile$ | async) === false"
    [class.flex--space-between]="(isMobile$ | async) === true"
  >
    <div class="flex flex--column">
      <div class="flex font-body-2 nordic-blue-300-text" [class.flex--end]="(isMobile$ | async) === false">
        {{ 'actions.from' | finLocalization }}
      </div>
      <div class="font-head-5 bold-type flex flex--end ms-xxsmall upsell-price">
        {{ service.upsell?.lowestPrice ?? service.totalPrice | finPrice }}
      </div>
    </div>
    <div
      class="flex ms-xsmall-t"
      [class.flex--end]="(isMobile$ | async) !== false"
      [class.flex--start]="(isMobile$ | async) === false"
    >
      @if (service.upsell?.updatingService !== true) {
        <fcom-button
          *ngIf="(isMobile$ | async) === false"
          [attr.data-testid]="'upsell-add-ancillary-' + service.category"
          [icon]="{ name: SvgLibraryIcon.PLUS, position: IconPosition.RIGHT }"
          [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
          [mode]="ButtonMode.FILL_MOBILE"
          [text]="'actions.add' | finLocalization"
          (clickBtn)="upsellClicked.emit(service.category)"
        />
        <fcom-icon-button
          [attr.data-testid]="'upsell-add-ancillary-' + service.category"
          *ngIf="(isMobile$ | async) === true"
          [icon]="{ name: SvgLibraryIcon.PLUS }"
          [aria]="{ label: 'actions.add' | finLocalization }"
          [theme]="IconButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
          (clickBtn)="upsellClicked.emit(service.category)"
        />
      } @else {
        <div class="fill flex flex--center">
          <fcom-loader [loaderType]="LoaderTheme.INLINE_TEXT" />
        </div>
      }
    </div>
  </div>
</div>
<ng-template #specialNeed>
  <fcom-notification [title]="'MMB.fragments.upsell.specialNeed.title' | finLocalization" class="ms-medium-b">
    <p [innerHTML]="article$ | finMap: 'detailText' | async"></p>
  </fcom-notification>
</ng-template>
